/**
 * Referral tracking helper.
 *
 * On any URL with `?ref=CODE`, save the code as a first-party cookie for 30
 * days and remove the query param (so it doesn't muck up canonical URLs / OG).
 *
 * `getRefCode()` returns the current stored code (or null) — call this in
 * checkout to pass along to the order-creation endpoints.
 */
const COOKIE_NAME = "endag1_ref";
const MAX_DAYS = 30;

function setCookie(value) {
  const d = new Date();
  d.setTime(d.getTime() + MAX_DAYS * 24 * 60 * 60 * 1000);
  const secure = window.location.protocol === "https:" ? "; Secure" : "";
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(value)}; expires=${d.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get("ref") || "").trim().toUpperCase();
    if (!ref) return;
    setCookie(ref);
    // Clean the URL so the ?ref= param isn't in every share link / history entry
    params.delete("ref");
    const clean = window.location.pathname + (params.toString() ? "?" + params.toString() : "") + window.location.hash;
    window.history.replaceState({}, "", clean);
  } catch (_) {
    /* fail silently — attribution is best-effort */
  }
}

export function getRefCode() {
  const match = document.cookie.match(new RegExp("(?:^|; )" + COOKIE_NAME + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}
